module.exports = __webpack_public_path__ + "static/media/chrome.33605cda.svg";